export default __webpack_public_path__ + "static/media/GONOGO_ICONA.ec88e967.svg";